import React, {
  createContext,
  useCallback,
  useEffect,
  useReducer,
  useRef,
} from 'react';
import { flatStateReducer } from '../utils';
import { StyledKakarikoStickyElement } from './styles';

import {
  IKakarikoStickyElementState,
  IKakarikoStickyElementProps,
  KakarikoStickyElementContextType,
} from './types';

export const setStateOnScroll = (
  element: any,
  state: IKakarikoStickyElementState,
  positionOverride: any,
): IKakarikoStickyElementState => {
  if (!positionOverride && (element === null || !element.current)) return state;
  let height;
  let left;
  let top;
  let width;
  if (positionOverride) {
    height = positionOverride()?.height;
    top = positionOverride()?.top;
    left = positionOverride()?.left;
    width = positionOverride()?.width;
  } else {
    height = element.current.getBoundingClientRect().height;
    top = element.current.getBoundingClientRect().top;
    left = element.current!.getBoundingClientRect().left;
    width = element.current!.getBoundingClientRect().width;
  }
  return {
    height,
    isSticky: state.isSticky
      ? state.stickyPoint > window.scrollY + height
      : top < 0,
    stickyPoint: !state.isSticky ? window.scrollY + top : 0,
    left,
    width,
  };
};

const isClone = { isClone: true };
export const KakarikoStickyElementContext =
  createContext<KakarikoStickyElementContextType>({});

export const KakarikoStickyElement = (props: IKakarikoStickyElementProps) => {
  const { className, children, positionOverride, styles } = props;

  const [state, dispatch] = useReducer<
    React.Reducer<IKakarikoStickyElementState, IKakarikoStickyElementState>
  >(flatStateReducer, {
    stickyPoint: 0,
    isSticky: false,
    height: '',
    left: '',
    width: '',
  });

  const elementRef = useRef(null);

  const handleScroll = useCallback(() => {
    const payload = setStateOnScroll(elementRef, state, positionOverride);
    if (payload) dispatch(payload);
  }, [state, positionOverride]);

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <KakarikoStickyElementContext.Provider value={isClone}>
      {state.isSticky && (
        <StyledKakarikoStickyElement
          $left={state.left}
          $width={state.width}
          style={styles}
          className={className}
        >
          {children}
        </StyledKakarikoStickyElement>
      )}
      {!positionOverride && (
        <span className="sticky-header" ref={elementRef}>
          {children}
        </span>
      )}
    </KakarikoStickyElementContext.Provider>
  );
};
